import React from "react"
const ShowSideError = (props) => {
    return (
        <div className="ShowSideError">
            <span>{props.errorMSG}</span>
        </div>
        )
}
export default ShowSideError